import styled from 'styled-components';

import { utils } from '@desygner/ui-common-components';

export const StyledLogo = styled.div`
  height: ${({ theme }) => utils.rem(theme.Icon.Size.Medium)};
  margin: ${({ theme }) => `0 ${utils.rem(theme.Spacing.Size.Small)}`};

  svg {
    width: fit-content;
    height: ${({ theme }) => utils.rem(theme.Icon.Size.Medium)};
  }
`;
